import React from 'react';
import PropertyCard from '../PropertyCard/PropertyCard';
import './SimilarProperties.css';

function SimilarProperties({ properties }) {
  return (
    <div className="similar-properties">
      <h2 className="section-title">Similar Properties</h2>

      <div className="similar-properties-scroll">
        {properties.map(property => (
          <div key={property.id} className="similar-property-item">
            <PropertyCard property={property} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default SimilarProperties;
